import { WemapPinpoint } from '../../../../design-system/components/wemap/types/Wemap';
import { createWemapRegionPinpoint } from '../../../../design-system/components/wemap/utilities/pinpoints';
import { GeolocationBoundaries } from '../../../../domains/Geolocation/Geolocation';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { DestinationTypeRegion } from '../../../destination/domain/types/destination';
import { Region } from '../types/region';

type RegionPinpointStyle = NonNullable<WemapPinpoint['geo_entity_shape']>['properties'];

export function formatRegionAsWemapPinpoint(
    region: PickDomain<Region, 'id' | 'name'>,
    boundaries: GeolocationBoundaries,
    style?: RegionPinpointStyle,
): WemapPinpoint {
    return createWemapRegionPinpoint({
        id: region.id,
        name: region.name,
        boundaries,
        style,
    });
}

export function formatDestinationRegionAsWemapPinpoint(
    destination: PickDomain<DestinationTypeRegion, 'id' | 'name'>,
    boundaries: GeolocationBoundaries,
    style?: RegionPinpointStyle,
): WemapPinpoint {
    return createWemapRegionPinpoint({
        id: destination.id,
        name: destination.name,
        boundaries,
        style,
    });
}
